import {
  CampaignsAddressPopupAction,
  CampaignsDuplicatedAction,
  CampaignsEditAction,
  CampaignsHeaderExpandedAction,
  UserAction
} from '../../types/user-actions';

export const isCampaignsAddressPopupAction = (
  action?: UserAction
): action is CampaignsAddressPopupAction => (
  action !== undefined
  && action.eventCategory === 'campaigns'
  && action.eventAction === 'address-popup-clicked'
);

export const isCampaignsDuplicatedAction = (
  action?: UserAction
): action is CampaignsDuplicatedAction => (
  action !== undefined
  && action.eventCategory === 'campaigns'
  && action.eventAction === 'campaign-duplicated'
);

export const isCampaignsEditAction = (
  action?: UserAction
): action is CampaignsEditAction => (
  action !== undefined
  && action.eventCategory === 'campaigns'
  && action.eventAction === 'campaign-edit'
);

export const isCampaignsHeaderExpandedAction = (
  action?: UserAction
): action is CampaignsHeaderExpandedAction => (
  action !== undefined
  && action.eventCategory === 'campaigns'
  && action.eventAction === 'campaign-header-expanded'
);
